// Rooms placed provisionally (for example scanned before any reference point
// was available) can be marked as awaiting registration. The mark is evidence
// only: it never moves geometry. A reference-point section move resolves it.
const id=v=>typeof v==='string'&&v.trim()===v&&v.length>0&&[...v].length<=80;
const date=v=>typeof v==='string'&&v.length<=40&&/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(v)&&Number.isFinite(Date.parse(v));
export const REGISTRATION_NOTE_LIMIT=500;

function rooms(plan,areaIDs){
  if(!plan||!id(plan.activeFloorId)||plan.activeFloorId==='@site-ground'||!Array.isArray(plan.areas))throw new Error('Choose one editable floor first.');
  if(!Array.isArray(areaIDs)||!areaIDs.length||areaIDs.length>32||!areaIDs.every(id)||new Set(areaIDs).size!==areaIDs.length)throw new Error('Choose 1 to 32 different rooms.');
  return areaIDs.map(areaID=>{const area=plan.areas.find(a=>a?.id===areaID);if(!area||area.kind!=='floor'||area.environment==='outdoor')throw new Error('Choose indoor rooms on this floor.');return area;});
}

/** Mark rooms as placed provisionally. Returns a new document. */
export function markAwaitingRegistration(plan,areaIDs,{note='',markedAt=new Date().toISOString()}={}){
  rooms(plan,areaIDs);
  if(typeof note!=='string'||[...note].length>REGISTRATION_NOTE_LIMIT)throw new Error(`Keep the note within ${REGISTRATION_NOTE_LIMIT} characters.`);
  if(!date(markedAt))throw new Error('The mark needs a valid time.');
  const doc=structuredClone(plan),mark={status:'awaiting-references',markedAt,recordedFloorID:plan.activeFloorId,roomIDs:[...areaIDs],...(note.trim()?{note:note.trim()}:{})};
  for(const areaID of areaIDs)doc.areas.find(a=>a.id===areaID).registration=structuredClone(mark);
  return doc;
}

/** Remove the provisional mark without moving anything. Returns a new document. */
export function clearAwaitingRegistration(plan,areaIDs){
  const selected=rooms(plan,areaIDs);
  if(!selected.some(a=>a.registration!==undefined))throw new Error('None of these rooms is awaiting registration.');
  const doc=structuredClone(plan);
  for(const areaID of areaIDs)delete doc.areas.find(a=>a.id===areaID).registration;
  return doc;
}

export const awaitingRegistration=area=>area?.registration!==undefined;

/** Validate a stored mark for the Site evidence review. */
export function registrationEvidence(area,floorID){
  const mark=area.registration;
  if(!mark||typeof mark!=='object'||mark.status!=='awaiting-references'||!date(mark.markedAt)||!id(mark.recordedFloorID)||!Array.isArray(mark.roomIDs)||!mark.roomIDs.length||mark.roomIDs.length>32||!mark.roomIDs.every(id)||!mark.roomIDs.includes(area.id)||mark.note!==undefined&&(typeof mark.note!=='string'||[...mark.note].length>REGISTRATION_NOTE_LIMIT))throw new Error('The awaiting-registration mark is invalid.');
  const moved=mark.recordedFloorID!==floorID,name=typeof area.name==='string'&&area.name.trim()?area.name.trim().slice(0,120):'Room',several=mark.roomIDs.length>1;
  return {status:'awaiting-registration',severity:'warning',assumption:true,assumptionCategory:'provisional-placement',title:`${name}: position awaiting registration`,
    detail:`This room${several?`, part of a section of ${mark.roomIDs.length} rooms,`:''} was placed provisionally. Move it with matched reference points before relying on its Site position.${mark.note?` Note: ${mark.note}`:''}${moved?' It was marked on another floor.':''}`,capturedAt:mark.markedAt};
}
